var map = {
	"./avatar.png": 308,
	"./blog-logo.png": 457,
	"./blog.png": 966,
	"./blog.webp": 63,
	"./chatgpt.jpeg": 449,
	"./chatgpt.webp": 482,
	"./comment-dark.png": 637,
	"./comment.png": 970,
	"./copilot.png": 754,
	"./dev.png": 644,
	"./ducks.jpg": 817,
	"./github-dark.png": 846,
	"./github.svg": 405,
	"./kiwani.jpg": 579,
	"./linkedin-dark.svg": 346,
	"./linkedin.svg": 328,
	"./logo.svg": 574,
	"./moon.png": 909,
	"./moony.png": 38,
	"./music.png": 138,
	"./nomad.jpg": 838,
	"./profile-dark.png": 361,
	"./profile.png": 254,
	"./rubber-duck.jpg": 13,
	"./rubber-ducky.jpg": 85,
	"./screenshot.png": 811,
	"./share-dark.png": 790,
	"./share.png": 300,
	"./shareD.png": 480,
	"./sun-ducks.avif": 284,
	"./sun.png": 132,
	"./sunny.png": 92,
	"./vector.jpg": 839,
	"./water-duck.jpeg": 801,
	"./work.png": 986
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 173;